/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/embedding.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Generates dense vector embeddings from multimodal input using a specified inference endpoint with the `embedding` task type. Use this function to generate query vectors for KNN searches from multimodal inputs against your vectorized data or other dense vector based operations.
 *
 * @example
 * FROM dense_vector_text METADATA _score
 * | EVAL query_embedding = EMBEDDING("be excellent to each other", "test_embedding_inference")
 * | WHERE KNN(text_embedding_field, query_embedding)
 * | SORT _score DESC
 * | LIMIT 10
 *
 * @example
 * ROW b64_input="This is an image"
 * | EVAL embedding = EMBEDDING("data:image/jpeg;base64,VGhpcyBpcyBhbiBpbWFnZQ==", "test_embedding_inference", {"type": "image"})
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'embedding',
  signatures: [
    {
      params: [
        {
          name: 'value',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'inference_id',
          type: 'keyword',
          optional: false,
          hint: {
            kind: 'entity',
            entityType: 'inference_endpoint',
            constraints: {
              task_type: 'embedding',
            },
          },
        },
        {
          name: 'options',
          type: 'function_named_parameters',
          optional: true,
          mapParams: '{name=\'type\', values=[], description=\'Content type of the input (e.g. "text", "image").\', type=[keyword]}, {name=\'timeout\', values=[], description=\'Timeout for the inference request (e.g. "30s", "1m").\', type=[keyword]}',
        },
      ],
      variadic: false,
      returnType: 'dense_vector',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
